// @flow
import * as React from 'react';
import type { RouterHistory } from 'react-router';
import queryString from 'query-string';
import { shuffleArray } from 'utils/functional';
import { listingSearchHomePath } from 'utils/searchHomePages';
import { getJson } from 'utils/http';
import type { RandomGradProgram } from 'api/shared';
import type { RandomGradProgramsBlockData } from 'api/cms';
import TileCarousel from 'components/TileCarousel';

const { useEffect, useState } = React;

const getGradPrograms = (areasOfStudy: ?(string[])) => {
  const args = queryString.stringify({
    area: areasOfStudy || []
  });
  const url = `/data/website/random-grad-programs?${args}`;

  return getJson(url).then(({ gradPrograms }) =>
    gradPrograms.map(gradProgram => ({
      city: gradProgram.addressCity,
      id: gradProgram.id,
      logo: gradProgram.logo,
      orgName: gradProgram.schoolName,
      name: gradProgram.name,
      state: gradProgram.addressStateCode,
      url: gradProgram.url
    }))
  );
};

const RandomGradProgramsBlock = ({
  data: { areasOfStudy, headline },
  history
}: {
  data: RandomGradProgramsBlockData,
  history: RouterHistory
}) => {
  const [gradPrograms, setGradPrograms] = useState([]);
  useEffect(
    () => {
      getGradPrograms(areasOfStudy).then(
        (programs: Array<RandomGradProgram>) => {
          setGradPrograms(shuffleArray(programs));
        }
      );
    },
    [areasOfStudy]
  );

  return (
    // <>
    <TileCarousel
      headline={headline}
      results={gradPrograms}
      history={history}
      seeAllText={
        /* TRANSLATORS: Link to grad program search */ getText(
          'See all Grad Programs'
        )
      }
      seeAllUrl={`${listingSearchHomePath('GRAD_PROGRAM')}?searchMode=true&q=`}
      listingType="GRAD_PROGRAM"
    />
  );
};

export default RandomGradProgramsBlock;
